<template>
    <div class="content">
       <h3>Laitteiden aktiivisuus <button class="btn btn-success" id="updateButton" v-on:click="getObservationsGroupedByDate()">Päivitä</button></h3>
        <div class="row">
            <div class="col-md-12">
                <div id="chartTarget" style="height: auto; width: 100%; display:none">
                    <canvas id="chartCanvas" width="600" height="auto" style="display: block; height: auto; width: 600px;"></canvas>
                    <div style="opacity:0;" class="chartTooltip center">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'activity-timeline',
        props: {
            devices: {},
            start: "",
            end: ""
        },
        data() {
            return {
                showActivity: false,
                timelineChart: null
            }
        },
        methods: {
            deviceDataLoaded(){
                let deviceStatuses = this.$store.getters.deviceStatuses
                // TODO: filter or array contains not working (?)
                let boolean = true;
                for(let status in deviceStatuses){
                    if(deviceStatuses[status] == true){
                        boolean = false
                    }
                }
                return boolean
            },
            getObservationsGroupedByDate(){
                let loaded = this.deviceDataLoaded()
                if(!loaded){
                    alert("Odota ensin, että laitteiden arvot on ladattu")
                    return false
                }

                if( this.start.getTime() > this.end.getTime()){
                    alert("Päättymispäivä on aloituspäivää aiemmin")
                    return false
                } else{

                    let labels = [];
                    let dataSets = [];
                    for(let device of this.devices){
                        let tempData = this.getDatesAndObservations(this.start, this.end, device.id);
                        labels.push(device.name)

                        let values = tempData.values

                        let dataArray = []

                        for(let v in values){
                            let singleValueArray = []
                            singleValueArray.push(values[v].startDate)
                            singleValueArray.push(values[v].endDate)
                            singleValueArray.push(values[v].value)
                            dataArray.push(singleValueArray)
                        }

                        let finalValues = {
                            "data": dataArray
                        }
                        dataSets.push(finalValues)

                    }

                    var data = {
                        "type": "timeline",
                        "options": {
                            tooltips: {
                                callbacks: {
                                    title: function(tooltipItem, data) {
                                        return data['labels'][tooltipItem[0]['datasetIndex']];
                                    }
                                }
                            },
                            responsive: true,
                            "elements": {
                                "rectangle":{
                                    "text": {
                                        "display": false
                                    }
                                },
                                "colorFunction": function(text, data, dataset, index) {
                                    let dataSetIndex = dataset._meta[Object.keys(dataset._meta)[0]].controller.index;

                                    if(text == "Off"){
                                        return Color('#ffffff00');
                                    } else{
                                        if(dataSetIndex % 4 === 0){
                                            return Color('#bfcfff'); //blue
                                        } else if((dataSetIndex+1) % 4 === 0) {
                                            return Color('#ffa5a5'); //red
                                        } else if((dataSetIndex+2) % 4 === 0){
                                            return Color('#dadaa7'); //yellow
                                        } else {
                                            return Color('#c8e7ed'); //green
                                        }
                                    }

                                },
                                "showText": false,
                                "textPadding": 4
                            },
                            "legend": {
                                "display": false
                            },
                            "scales": {
                                "xAxes": [{
                                    "type": 'timeline',
                                    "time": {
                                        "unit": 'day',
                                        "unitStepSize": 1
                                    },
                                    "position": 'bottom',
                                    "distribution": 'linear',
                                    "categoryPercentage": 0.8,
                                    "barPercentage": 0.9,
                                    "gridLines": {
                                        "display": true,
                                        // offsetGridLines: true,
                                        "drawBorder": true,
                                        "drawTicks": true
                                    },
                                    "ticks": {
                                        "autoSkip": true,
                                        "maxTicksLimit": 20,
                                        "maxRotation": 0,
                                        "fontSize": 8,
                                        callback: function(value, index, values) {
                                            let tempValue = ""
                                            if(values[index]!=undefined){
                                                if(values[index].value != undefined){
                                                    var dateTime = new Date(values[index].value);
                                                    var year = dateTime.getFullYear()
                                                    var month = dateTime.getMonth()
                                                    var date = dateTime.getDate()
                                                    tempValue = date + '.' + (month+1) + '.' + year;
                                                }
                                            }
                                            return tempValue
                                        }

                                    },
                                }]
                            },
                        },
                        "data": {
                            "labels": labels,
                            "datasets": dataSets
                        },
                    };

                    if (this.timelineChart) {
                        this.timelineChart.destroy()
                        this.timelineChart = null
                    }

                    this.timelineChart = new Chart($('#chartCanvas')[0], data)
                    document.getElementById("chartTarget").style.display = "block";
                }
            },
            getCustomDate(date){
                let day = this.pad(date.getDate());
                let month = this.pad(date.getMonth() + 1);
                let year = this.pad(date.getFullYear());

                let compareDate = year + '-' + month + '-' +day
                return compareDate
            },
            getDatesAndObservations(startDate, stopDate, deviceId) {
                let currentDate = new Date(startDate.getTime())
                let compareEnd = stopDate.toDateString()

                let dateArrayObject = {
                    id: deviceId,
                    values: []
                }

                while (currentDate.toDateString() != compareEnd )  {

                    let startDate = currentDate;
                    let endDate = new Date(startDate);
                    endDate.setDate(currentDate.getDate()+1);

                    dateArrayObject.values.push({startDate: this.getCustomDate(startDate), endDate: this.getCustomDate(endDate)} )
                    currentDate.setDate(currentDate.getDate() + 1)

                }

                let endDateForLast = new Date(currentDate);
                endDateForLast.setDate(currentDate.getDate()+1);

                dateArrayObject.values.push({startDate: this.getCustomDate(currentDate), endDate: this.getCustomDate(endDateForLast)} )

                let observationsFromStore = this.$store.getters.devicesObservations[deviceId]
                if(observationsFromStore != undefined) {
                    //
                    let firstObservations = observationsFromStore[0].observations

                    for (let d in dateArrayObject.values) {
                        var result = firstObservations.find(obj => {
                            let status = obj.time.startsWith(dateArrayObject.values[d].startDate)
                            return status
                        })

                        if(result != null){
                            dateArrayObject.values[d]["value"] = "On"
                        } else{
                            dateArrayObject.values[d]["value"] = "Off"
                        }
                    }

                } else{
                    for (let d in dateArrayObject.values) {
                        dateArrayObject.values[d]["value"] = "Off"
                    }
                }
                return dateArrayObject
            },
            pad: function(number) {
                if (number < 10) {
                    return "0" + number
                } else {
                    return number
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/app/Main/components/ActivityTimeline.vue